export default __webpack_public_path__ + "static/media/RunHorseLight_2_1.5370296b.jpg";